export const NEWLINE = '\n';
export const SEPERATOR_COMMA = ',';
export const SEPERATOR_SEMILCOLON = ';';

export enum csvSeperatorType {
  SEPERATOR_COMMA = ',',
  SEPERATOR_SEMILCOLON = ';',
}
